import Rule from '../Rule'
import AfterOrEqual from './AfterOrEqual'
import BeforeOrEqual from './BeforeOrEqual'

export default class Adult extends Rule {
  get ruleName () {
    return 'adult'
  }

  passes () {
    return new AfterOrEqual(this.value, global.moment()
      .subtract(120, 'y')
      .format()).passes() && new BeforeOrEqual(this.value, global.moment()
      .subtract(18, 'y')
      .format())
      .passes()
  }
}
